import Alert, { AlertColor } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Portal from '@mui/material/Portal';
import Fade from '@mui/material/Fade';
import { alertSx } from './AutoHideSnackBar.style';
import React from 'react';

type AutoHideSnackbarProps = {
  children: React.ReactNode;
  open?: boolean;
  severity: AlertColor;
  onClose?: () => void;
  icon?: React.ReactNode;
};
const IconWrapper = ({ children, ...props }: any) => {
  const servity = props?.ownerState?.severity;
  const capitalizeServity = servity?.charAt(0).toUpperCase() + servity?.slice(1);
  return (
    <div {...props}>
      {React.cloneElement(children, {
        'data-testid': `${capitalizeServity}OutlinedIcon`,
      })}
    </div>
  );
};

export const AutoHideSnackbar: React.FC<AutoHideSnackbarProps> = ({
  children,
  severity,
  open = false,
  onClose,
  icon,
}) => {
  return (
    <Portal>
      <Snackbar open={open} TransitionComponent={Fade} autoHideDuration={4000} onClose={onClose}>
        <Alert
          icon={icon}
          onClose={onClose}
          variant="filled"
          sx={alertSx}
          severity={severity}
          slots={{ icon: icon ? undefined : IconWrapper }}
        >
          {children}
        </Alert>
      </Snackbar>
    </Portal>
  );
};
